import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import {
  BILLING_STATUS_LABELS,
  BILLING_STATUS_COLORS,
  BILLING_STATUS_BG_COLORS,
} from './constants';

const useStyles = makeStyles(() => ({
  badge: {
    fontWeight: 600,
    fontSize: '0.7rem',
    height: 22,
    borderRadius: 11,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: 4,
    flexShrink: 0,
  },
  withDot: {
    display: 'inline-flex',
    alignItems: 'center',
  },
}));

/**
 * BillingStatusBadge — renders a colored Chip for the surgery billing status.
 *
 * Usage:
 *   <BillingStatusBadge status="pre_auth_pending" />
 *   <BillingStatusBadge status="co_pay_pending" variant="outlined" />
 *   <BillingStatusBadge status="cash_unpaid" showDot />
 */
const BillingStatusBadge = ({
  status,
  size = 'small',
  variant = 'default',
  showDot = false,
  className = '',
}) => {
  const classes = useStyles();
  const label = BILLING_STATUS_LABELS[status] || status || 'Unknown';
  const color = BILLING_STATUS_COLORS[status] || '#9E9E9E';
  const bgColor = BILLING_STATUS_BG_COLORS[status] || '#F5F5F5';

  if (showDot) {
    return (
      <span className={`${classes.withDot} ${className}`}>
        <span className={classes.dot} style={{ backgroundColor: color }} />
        <Chip
          label={label}
          size={size}
          className={classes.badge}
          style={{
            backgroundColor: bgColor,
            color: color,
            border: `1px solid ${color}30`,
          }}
        />
      </span>
    );
  }

  const chipStyle =
    variant === 'outlined'
      ? { border: `1px solid ${color}`, color: color, backgroundColor: 'transparent' }
      : { backgroundColor: bgColor, color: color, border: `1px solid ${color}30` };

  return (
    <Chip
      label={label}
      size={size}
      className={`${classes.badge} ${className}`}
      style={chipStyle}
    />
  );
};

export default BillingStatusBadge;
